import GlobalUnit from "../../common/GlobalUnit";
import LayerDefine from "../../common/LayerDefine";
import PlayerLogic from "../play/PlayerLogic";
import ItemBase from "./ItemBase";
export default class ItemDoor_value extends ItemBase {
    OnInit() {
        this.group = LayerDefine.Door;
        this.mask = LayerDefine.Root;
        this.CreateModel();
        this.CreateBody();
        GlobalUnit.game.text.InitText(this.rootObj, this.types);
    }
    ChangeParamsToAdd() {
        let mathType = this.types[2];
        switch (mathType) {
            case 2:
                this.types[2] = 1;
                GlobalUnit.game.text.InitText(this.rootObj, this.types);
                break;
            case 4:
                this.types[2] = 3;
                GlobalUnit.game.text.InitText(this.rootObj, this.types);
                break;
        }
    }
    BeginContact(other) {
        if (other instanceof PlayerLogic) {
        }
    }
    OnUpdate(dt) {
        this.FromOwnerTrans();
    }
}
